<template>
    <section class="project"  v-if="loaded && ready"  :class="inplay">

      <div class="container"  :class="{'vis' :  offSet.last >= 0}">



        <!--div class="project-col">

        </div-->


        <div class="project-new-col1">
          <div class="btn-back" v-on:click="goIdedas">
            <span v-if="lang==0">voltar</span>
            <span v-if="lang==1">back</span>



          </div>

          <div class="project-title-box">
            <div class="project-title">{{projData.title[0].name}}</div>
            <div class="project-tags">
              <span v-for="(item, index) in projData.tags">{{item.name[lang].name}}</span><span>|</span>
              <span  >{{projData.client[0].name}} </span>
              <!--span v-for="(item2, index) in projData.industry">{{item2.item[lang].name}}</span>
              <span v-for="(item3, index) in projData.serivce"> {{item3.item[lang].name}}</span-->
            </div>

          </div>

        </div>
        <div class="project-new-col2 media-col">
          <media-type :className="'proj-media'" :obj="projData.media"  :dynAlt="projData.title[0].name">  </media-type>
        </div>
      </div>


      <div class="container"  :class="{'vis' :   offSet.last >= 1}">

        <div class="project-new-col1">

        </div>
        <div class="project-new-col2">

            <div class="project-biref" v-if="lang==0">Ideia</div>
            <div class="project-biref" v-if="lang==1">Idea</div>
            <p v-html="projData.idea[lang].name">   </p>

        </div>
      </div>
      <!--
            <div class="container"  :class="{'vis' :   offSet.last >= 2}">


              <carousel :per-page="1"  :paginationEnabled="true" ref="carousel"  class="carousel"  @pageChange="onPageChange" >
                <slide class="slide" v-for="(item, index) in projData.carroucel" >
                  <media-type :className="'proj-media-caroucel'" :obj="item" :dynAlt="projData.title[lang].name">  </media-type>
                </sl



              </carousel>
            </div>
      -->


      <div class="container container-caroucel" v-for="(item, index) in projData.carroucel"   :class="{'vis' : offSet.last >= (2 + index) }">

        <img src="/static/images/ref-img.png" alt="Nossa work" class="ref-img" v-if="offSet.last < (2 + index)">

        <media-type :className="'proj-media-caroucel'" :obj="item"    :dynAlt="projData.title[0].name" v-if="offSet.last >= (2 + index)">  </media-type>
      </div>

      <div class="container links" :class="{'vis' : offSet.last >= (2 + projData.carroucel.length)}" v-if="projData.links">

        <h3 v-if="projData.links.title">{{projData.links.title[0].name}}</h3>
        <div  v-if="projData.links.title" class="links-item" v-for="(item, index) in projData.links.links.items">
          <h4>{{item.title[0].name}}</h4>
          <Icons :id="'url'"></Icons>


          <a target="_blank" :href="item.link">{{item.link}}</a>
        </div>

      </div>


<!--
      <div class="proj-rel">
        <div class="container" :class="{'vis' : offSet.last >= (2 + projData.carroucel.length)}">
          <div class="project-col" >
            <div class="proj-rel-title">Projectos recomendados</div>
            <proj-card :projId="projData.rel[0]" :lang="lang"></proj-card>
          </div>
          <div class="project-col" >
            <div class="proj-rel-title">&nbsp;</div>
            <proj-card :projId="projData.rel[1]" :lang="lang"></proj-card>
          </div>

        </div>

      </div>
-->

      <div class="container proj-rel" :class="{'vis' : offSet.last >= (2 + projData.carroucel.length)}">
        <div class="proj-rel-title">


          <span v-if="lang==0">Mais projetos incontornáveis</span>
          <span v-if="lang==1">More unavoidable projects</span>
        </div>
        <div class="grid-ideas">
          <transition-group name="fade" >
            <a class="grid-iideas-item" v-for="(item, index) in rel"
               :key="index"
               :href="item.route + '?lang=' + langs[lang]"
               :class="[{'vis' : offSet.last >= (2 + projData.carroucel.length)},
                {'grid-ideas-item-large' : index < 4},
               {'grid-ideas-item-normal' : index >= 4}]"
            >

              <img src="/static/images/ref-img.png" alt="Nossa work" class="ref-img" v-if="offSet.last < index">
              <div class="box-anim">
                <media-type :className="'grid-ideas-media'" :obj="item.cover"  :dynAlt="item.title[0].name" v-if="offSet.last >= index" :thumb="true"> </media-type>

                <div class="info-case">
                  <h4>{{item.client[0].name}}</h4>
                  <h3>{{item.title[0].name}}</h3>


                </div>

              </div>

            </a>
          </transition-group>

        </div>
      </div>

      <div class="project-footer">
        <footer-nossa :lang="lang" :isMobile="isMobile"></footer-nossa>
      </div>




    </section>
</template>

<script>

import { Carousel, Slide } from 'vue-carousel';


    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, PROJ, WP} from '../main';
    import MediaType from "./Modules/MediaType";
    import ProjCard from "./Modules/ProjCard";
    import FooterNossa from "./FooterNossa";
import Icons from './Modules/Icons';



    export default {


        name: 'Project',
      components: {Icons, FooterNossa, ProjCard, MediaType},
      props: ['actRoute', 'isMobile', 'lang'],
        data() {
            return {
                actScreen: 0,
              projData: [],
              loaded: false,
              ready: false,
              offSet: {
                  vis: [],
                  tops: [],
                  last: -1
              },
              inplay: '',
              vFoot: false,
              rel:[],
              langs: ['pt', 'en'] ,
            }
        },
/*
      head: {
        title: function () {
          const _this = this;
          return {
            inner: 'NOSSA™',   separator: '|',   complement: _this.projData.title[_this.lang].name
          }
        },


      },
*/
      created() {
        const _this = this;



        PROJ('route', this.$route.params.id, function (response){

          _this.projData = response[0];
          _this.loaded = true;

          for(let i = 0; i < (4 + _this.projData.carroucel.length); i++){
            if(i === 0) {
              _this.offSet.vis.push(true)
            }else{
              _this.offSet.vis.push(false)
            }
          }






          for(let i = 0; i < _this.projData.rel.length; i++){


            PROJ('id', _this.projData.rel[i], function (resp){


              _this.rel.push(resp[0])
               if(_this.rel.length == _this.projData.rel.length){
                 _this.init();
               }

            });
          }



        });

      },
      beforeMount() {

        this.resizeVid();
      },
      mounted() {
        this.ready = true;
        this.resizeVid();
        this.init();
        EVENTBUS.$on('goPlay', this.goPlay);
        //EVENTBUS.$emit('AAA', 0);

        $(window).scrollTop(0);
        $('body, html').scrollTop(0);



      },

      destroyed() {

        $( window ).off();
      },

      methods: {

        goPlay(s){
          console.log(s)

          const _this = this;

          /*
          if(s == 'inplay'){
            $(window).scrollTop(0);
            $('body, html').scrollTop(0);


          }


          setTimeout(function () {

          }, 1000);

           */

          if(_this.isMobile){
            _this.inplay = '';
          }else{


            if(s == 'inplay'){
              if( $( window ).scrollTop() !== 0){
                $(window).scrollTop(0);
                $('body, html').scrollTop(0);
                setTimeout(function () {
                  _this.inplay = s;
                }, 500);
              }else{
                _this.inplay = s;
              }
            }else{
              _this.inplay = s;
            }
            console.log( $( window ).scrollTop())

          }

        },

        init() {
          const _this = this;

          if(this.loaded && this.ready){

            _this.initScroll();
            _this.resizeVid();


            $('main').css('pointer-events', 'auto');


          }
        },


        initScroll(){
          const _this = this;
          console.log(_this.offSet)
          setTimeout(() =>{

            $('.container').each(function(i){

              _this.offSet.tops.push($(this).offset().top);

            });

            $( window ).scroll(function(e) {

              _this.scrollEvt()
            });

            $( window ).resize(function() {
              _this.reseizeMe();
            });

            _this.reseizeMe();
            _this.scrollEvt();
            _this.offSet.last = 1;
          }, 100)


        },

        reseizeMe() {
          this.scrollEvt()
        },

        scrollEvt() {

          const _this = this;
          console.log('');
          _this.goPlay('');
          _this.offSet.act =  $( window ).scrollTop() +  $( window ).height();

          $('.container').each(function(i){

            if(_this.offSet.act > (_this.offSet.tops[i]  + 200)&&  !_this.offSet.vis[i]) {

              _this.offSet.last = i;
              _this.offSet.vis[i] = true;
            }

          });


          if(($('.container').length - 1) === _this.offSet.last && !_this.vFoot){
            EVENTBUS.$emit('showFooter');
            _this.vFoot = true;
          }

         // EVENTBUS.$emit('goPlay', '');

          _this.resizeVid();




        },

        resizeVid(){
          let refH =  56 *($('.media-col').width() / 100);
          let refH2 =  56 *($('.proj-media-caroucel.vid').width() / 100);





          $('.media-col').height(refH);
          $('.proj-media-caroucel.vid').height(refH2);


        },


        onPageChange(n){

        },

        goIdedas(){
          this.$router.replace( '/ideas');
        },



        },
    };

</script>


// WEBPACK FOOTER //
// src/components/Project.vue